import { useHover } from '@mantine/hooks';
import { AnimatePresence, motion } from 'framer-motion';
import { useCallback } from 'react';
import { Content, FormatContent } from 'src/contexts/ContentContext';
import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';
import { vars } from 'src/core/themes';
import { Button, Stack } from 'src/core/ui';
import { RecommendationsIcon } from 'src/svgs';
import { IconsFill } from 'src/svgs/Viagogo';
import { ContentId } from 'src/utils/constants/contentId';
import { FormatContentId } from 'src/utils/constants/formatContentId';

import * as styles from './SectionScoreRecommendations.css';

export const SectionScoreRecommendations = ({
  recommendingSectionIds,
  useSave = false, // Flag to tell if we want to remove/save, save is used for mobile experience
  onDeclineRecommendation,
  onSaveRecommendation,
}: {
  recommendingSectionIds?: number[];
  useSave?: boolean;
  onDeclineRecommendation: () => void;
  onSaveRecommendation?: () => void;
}) => {
  const { ref, hovered } = useHover();
  const { isDarkMode } = useSiteTheme();

  const onActionClick = useCallback(() => {
    if (useSave) {
      onSaveRecommendation?.();
    } else {
      onDeclineRecommendation();
    }
  }, [onDeclineRecommendation, onSaveRecommendation, useSave]);

  return (
    <Stack
      ref={ref}
      alignItems="center"
      gap="s"
      className={styles.container}
      style={{
        color: isDarkMode ? vars.color.surfacePrimary : vars.color.textInverted,
      }}
    >
      <RecommendationsIcon
        fill={IconsFill.currentColor}
        size={vars.iconSize.s}
      />
      <FormatContent
        id={FormatContentId.RecommendedSections}
        params={recommendingSectionIds?.length + ''}
      />
      <AnimatePresence>
        {hovered && (
          <motion.div
            layout
            initial={{ width: 0, opacity: 0 }}
            animate={{ width: 'auto', opacity: 1 }}
            exit={{ width: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
          >
            <Button
              variant="textPlain"
              onClick={onActionClick}
              style={{
                color: isDarkMode
                  ? vars.color.surfacePrimary
                  : vars.color.textInverted,
              }}
            >
              <Content id={useSave ? ContentId.Save : ContentId.Remove} />
            </Button>
          </motion.div>
        )}
      </AnimatePresence>
    </Stack>
  );
};
